import { supabase } from '@/core/database/supabase';

export const adminDashboardService = {
  getKpiMetrics: async () => {
    // We will query in parallel to get the counts for users, companies, etc.
    const [usersRes, companiesRes, rolesRes] = await Promise.all([
      supabase.from('users').select('id', { count: 'exact', head: true }),
      supabase.from('companies').select('id', { count: 'exact', head: true }),
      supabase.from('roles').select('code', { count: 'exact', head: true }),
    ]);

    if (usersRes.error) throw new Error(`Lỗi query users: ${usersRes.error.message}`);
    if (companiesRes.error) throw new Error(`Lỗi query companies: ${companiesRes.error.message}`);
    if (rolesRes.error) throw new Error(`Lỗi query roles: ${rolesRes.error.message}`);

    return {
      totalUsers: usersRes.count || 0,
      totalCompanies: companiesRes.count || 0,
      totalRoles: rolesRes.count || 0,
      // Fake system status and storage since we don't have DB tables for server health
      systemStatus: 'Tốt',
      storageUsed: '256.7 GB',
      storageProgress: 64,
    };
  }
};
